<template>
  <div>
    <base-header v-show="showHeader" type class="rsgradient pb-3 pb-1 pt-3 pt-md-5" />
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Enviá Dinero</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <label>A quien desea enviarle dinero?</label>
            <KitsBusqueda
              url="Account/GetAccounts"
              placeholder="Nombre, DNI o Mail..."
              v-model="model.Cuenta"
              :currentValue="model.Cuenta"
            />
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <money-with-indicator
              v-model="model.Importe"
              v-on:validatedOK="onAvailableOK"
              :key="moneyWInd"
              :max-value="limiteDiarioDisponible"
            />
          </div>
          <div class="col-md-12" style="font-weight: bolder">
            <label v-text="model.Limit"></label>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label>Referencia</label>
            <base-input v-model="model.Referencia" placeholder="Motivo"></base-input>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <save-button text="Enviar" @click="onEnviarDinero" :disabled="btnEnviarDisabled" />
          </div>
        </div>
      </b-card-body>
    </b-card>
    <contact-help-desk ref="contact-help-desk" titleModal="Solicitud Rechazada" />
    <pin-validation
      ref="pin-validation"
      :showModal.sync="showModalPinValidation"
      v-on:validPin="onValidPin"
      v-on:loadUsePaymentPin="onLoadUsePaymentPin"
    ></pin-validation>

    <modal :show.sync="showNextLevelModal">
      <template slot="header">
        <h5 class="modal-title">Operación realizada con éxito</h5>
      </template>
      <div>
        <p class="text-center">
          <img src="@/assets/icon-success.png" height="80px" />
        </p>
        <p
          class="text-center"
        >Hola! Desde Resimple queremos mejorar la seguridad, por eso vamos a solicitarte más información.</p>
      </div>
      <template slot="footer">
        <base-button type="primary" @click="goToValidateIdentity">Continuar</base-button>
      </template>
    </modal>
    <modal-with-link ref="modal-with-link" />
  </div>
</template>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import KitsBusqueda from "@/components/KitsBusqueda";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);
import PinValidation from "@/views/Pin/PinValidation";
import MoneyWithIndicator from "@/components/Custom/MoneyWithIndicator";
import ContactHelpDesk from "@/views/ContactHelpDesk";
import ModalWithLink from "@/components/ModalWithLink.vue";

export default {
  components: {
    KitsBusqueda,
    "modal-with-link": ModalWithLink,
    "pin-validation": PinValidation,
    "money-with-indicator": MoneyWithIndicator,
    "contact-help-desk": ContactHelpDesk
  },
  props: {
    propShowHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      model: {
        Importe: 0,
        Referencia: "",
        Cuenta: null,
        Limit: ""
      },
      // Tope del input de Importe. Arranca en el mismo valor que el default
      // de MoneyWithIndicator y se actualiza con el límite diario real
      // apenas responde TransferenceOuterLimitRemain (ver loadLimitRemain()).
      limiteDiarioDisponible: 9999999,
      helpDeskInformation: {
        Message: "",
        Show: false,
        ShowInfo: false,
        WhatsappUrl: "",
        PhoneNumber: "",
        EmailAddress: "",
        EmailSubject: "",
        MessageBody: "",
        ShowUnlockMail: false,
        Name: "",
        ShowContactarSoporte: false
      },
      usePaymentPin: false,
      showModalPinValidation: false,
      showNextLevelModal: false,
      showHeader: this.propShowHeader,
      btnEnviarDisabled: false,
      moneyWInd: 0
    };
  },
  mounted() {
    this.loadLimitRemain();
  },
  methods: {
    goToValidateIdentity() {
      let context = this;
      context.showNextLevelModal = false;
      context.$router.push("verificacionidentidad");
    },
    onEnviarDinero() {
      this.validate();
    },
    validate() {
      if (this.model.Cuenta == null) {
        notificationHelpers.showWarning(
          "Alerta",
          "Debe seleccionar a quien enviar dinero",
          this
        );
        return;
      }
      if (this.model.Importe <= 0) {
        notificationHelpers.showWarning(
          "Alerta",
          "El importe debe ser superior a 0",
          this
        );
        return;
      }

      this.pinValidate();
    },
    enviarDinero() {
      let req = {
        Amount: this.model.Importe,
        Reference: this.model.Referencia,
        DestinyAccountID: this.model.Cuenta.EntityID
      };

      let context = this;
      
      axiosHelpers.axiosPostWithoutAlerts(
        "Account/SendMoney",
        req,
        this,
        function(data) {
          if (data.ResponseVM.LimitReached || data.ResponseVM.DestinyAccountLimitReached) {
            context.model.viewResult = false;
            context.helpDeskInformation.Show = true;
            context.helpDeskInformation.ShowContactarSoporte = true;
            context.helpDeskInformation.Message = data.Alerts[0].Message;
            context.helpDeskInformation.EmailAddress =
              context.$store.getters.EmailAddress;
            context.helpDeskInformation.EmailSubject =
              context.$store.getters.EmailSubject;
            context.helpDeskInformation.MessageBody =
              context.$store.getters.MessageBody;
            context.helpDeskInformation.UrlWhatsapp =
              context.$store.getters.UrlWhatsapp;
            context.helpDeskInformation.PhoneNumber =
              context.$store.getters.PhoneNumber;
            context.$refs["contact-help-desk"].setHelpDeskInformation(
              context.helpDeskInformation
            );
          } else if (data.ResponseVM.Success) {
            if (data.ResponseVM.CloseToExceedingLimit) {
              context.showNextLevelModal = true;
            } else {
              notificationHelpers.showSuccess(
                "Exito",
                "Se envió el dinero correctamente",
                context
              );
              context.moneyWInd += 1;
              context.loadLimitRemain();
            }

            context.model.Importe = 0;
            context.model.Referencia = "";
          } else if (!data.ResponseVM.Success) {
            notificationHelpers.showError(
              "Error",
              "La billetera destino no puede realizar ésta operación",
              context
            );
            context.model.Importe = 0;
            context.model.Referencia = "";
          }
        },
        function(message) {
          context.$refs["modal-with-link"].showModalWithParams(
            "Solicitud Rechazada",
            message,
            "verificacionidentidad",
            "Continuar"
          );
        },
        function() {
          context.model.viewResult = false;
          context.helpDeskInformation.Show = true;
          context.helpDeskInformation.ShowContactarSoporte = true;
          context.helpDeskInformation.Message = 
          'Superaste tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
          context.helpDeskInformation.EmailAddress =
            context.$store.getters.EmailAddress;
          context.helpDeskInformation.EmailSubject =
            context.$store.getters.EmailSubject;
          context.helpDeskInformation.MessageBody =
            context.$store.getters.MessageBody;
          context.helpDeskInformation.UrlWhatsapp =
            context.$store.getters.UrlWhatsapp;
          context.helpDeskInformation.PhoneNumber =
            context.$store.getters.PhoneNumber;
          context.$refs["contact-help-desk"].setHelpDeskInformation(
            context.helpDeskInformation
          );
        }
      );
    },
    onValidPin(val) {
      if (val) {
        this.enviarDinero();
      }
    },
    onLoadUsePaymentPin(val) {
      this.usePaymentPin = val;
    },
    pinValidate() {
      if (this.usePaymentPin) {
        this.showModalPinValidation = true;
      } else {
        this.enviarDinero();
      }
    },
    onAvailableOK(val) {
      this.btnEnviarDisabled = !val;
    },
    loadLimitRemain() {
      let context = this;
      let req = {};
      axiosHelpers.axiosPost(
        "TransferenceContact/TransferenceOuterLimitRemain",
        { req },
        this,
        function(data) {
          context.model.Limit =
            "Limite diario disponible: " + data.ResponseVM.FormattedAmount;

          context.limiteDiarioDisponible = data.ResponseVM.Amount;
        }
      );
    }
  }
};
</script>